import fetchRestData from '../../helpers/fetchResData'

/**
 * Given a flyerId and a gibId, fetch a single flyer gib
 * @param {Object} params
 * @param {string} params.flyerId
 * @param {string} params.gibId
 */

export const fetchFlyerGib = ({ flyerId, gibId }) => {
  const options = {
    resource: `flyers/${flyerId}/flyer_gibs/${gibId}`,
    paginate: false,
    dataOnly: true,
    oneResource: true,
  }

  return fetchRestData(options)
}
